var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "product_revenue",
          route_grid_path: "/grid",
          order_column: "total_revenue",
          direction: "desc",
          "show-export": true,
          "export-types": ["csv", "xls"],
          "export-filename": "hubee_product_revenue",
          "fetch-on-mounted": false,
          hide_actions: "true",
          hide_searchbar: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c("FinancialPeriodFilter", {
                  attrs: {
                    "show-product-filter": true,
                    "show-institution-filter": true,
                  },
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v("Produto"),
                ]),
                _c("vs-th", { key: "type", attrs: { "sort-key": "type" } }, [
                  _vm._v("Tipo"),
                ]),
                _c(
                  "vs-th",
                  {
                    key: "total_quantity",
                    attrs: { "sort-key": "total_quantity" },
                  },
                  [_vm._v("Quantidade Vendida")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "total_orders",
                    attrs: { "sort-key": "total_orders" },
                  },
                  [_vm._v("Total de Pedidos")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "total_revenue",
                    attrs: { "sort-key": "total_revenue" },
                  },
                  [_vm._v("Receita Total")]
                ),
                _c(
                  "vs-th",
                  {
                    key: "avg_order_value",
                    attrs: { "sort-key": "avg_order_value" },
                  },
                  [_vm._v("Ticket Médio")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "name", attrs: { width: "25%" } }, [
                      _c("div", { staticClass: "font-semibold" }, [
                        _vm._v(_vm._s(tr.name)),
                      ]),
                    ]),
                    _c("vs-td", { key: "type", attrs: { width: "10%" } }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.formatProductType(tr.type))),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "total_quantity", attrs: { width: "13%" } },
                      [_c("div", [_vm._v(_vm._s(tr.total_quantity))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "total_orders", attrs: { width: "13%" } },
                      [_c("div", [_vm._v(_vm._s(tr.total_orders))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "total_revenue", attrs: { width: "20%" } },
                      [
                        _c(
                          "span",
                          { staticClass: "font-semibold text-success" },
                          [_vm._v(_vm._s(_vm.formatCurrency(tr.total_revenue)))]
                        ),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "avg_order_value", attrs: { width: "19%" } },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatCurrency(tr.avg_order_value))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }